import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PersonModel } from '../../person/models/person.model';
import { DriverModel, DriverBlockModel } from '../models/driver.model';
import { DriverService } from '../models/driver.service';
import { SharedVehicleGroupModel } from '../../sharedvehiclegroup/models/sharedvehiclegroup.model';
import { PersonService } from '../../person/models/person.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, IKeyValueInterface, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { InstanceService } from "../../instance/models/instance.service";

@Component({
  selector: 'wego-driver-list',
  template: require('../views/driver-list.component.html'),
  providers: [DriverService, PersonService, InstanceService],
})
export class DriverListComponent implements OnInit {
  DataListModel: DataListModel;
  driverList: DriverModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  deleteDriverHashId: string;
  inActiveDriverHashId: string;
  licenseNumber: string;
  activeFlag: boolean;
  message: string;
  inActiveMessage: string;
  removeLicenseNumber: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  model: DriverBlockModel;
  urlDefaultPage: string;
  urlDriverUpdate: string;
  urlDriverSVGList: string;
  resetPasswordPersonHashId: string;
  errorMessage: string;
  urlPersonUpdate: string;
  errorModel: IKeyValueInterface[];
  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  isAllowToBatchUploadPerson: boolean = false;
  urlBatchUpload: string;

  @ViewChild('childModal') public childModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('addDriverModal') public addDriverModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('removeLicenseModel') public removeLicenseModel: any;
  @ViewChild('successPopup') public successPopup: any;

  get isAnyChecked(): boolean {
    if (this.driverList) {
      let isCheck = this.driverList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.driverList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(private driverService: DriverService,
    private router: Router,
    private authService: AuthService,
    private personService: PersonService,
    private translate: TranslateService,
    private instanceService: InstanceService, ) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblDriver');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
    this.model = new DriverBlockModel();
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlDriverSVGList = this.authService.GetURL(ApplicationRouteURL.URL_DRIVER_SVG_LIST);
    this.urlDriverUpdate = this.authService.GetURL(ApplicationRouteURL.URL_DRIVER_UPDATE);
    this.urlPersonUpdate = this.authService.GetURL(ApplicationRouteURL.URL_PERSON_UPDATE);
    this.urlBatchUpload = this.authService.GetURL(ApplicationRouteURL.URL_BATCHUPLOADPERSON);
    this.CheckIsAllowToBatchUploadPerson();
    this.GetDriverList();
  }

  onSubmit(forms: any) {
    this.model.activeFlag = this.activeFlag;
    this.model.driverHashId = this.inActiveDriverHashId;

    this.InActiveDriver(JSON.stringify(this.model));
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetDriverList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.driverService.ExportDriverList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Driver" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public GetDriverList() {
    this.isLoading = true;
    this.driverService.GetDriverList(this.DataListModel)
      .subscribe(
      res => {
        this.driverList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  // public DeleteDriver(deleteDriverList: string[]) {
  //   this.isLoading = true;
  //   this.driverService.DeleteDriver(deleteDriverList)
  //     .subscribe(
  //     res => {
  //       this.DataListModel.currentPage = 1;
  //       this.GetDriverList();
  //       this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
  //       this.ShowSuccessPopup();
  //     },
  //     error => {
  //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
  //       this.isLoading = false;
  //     });
  // }

  public OnParentCheck(isChecked: boolean) {
    this.driverList.forEach(x => x.isChecked = isChecked);
  }

  public ShowChildModal(driverHashId?: string): void {
    if (driverHashId) {
      this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteDriverHashId = driverHashId;
    }
    else {
      this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.childModal.show();
  }

  // public HideChildModal(): void {
  //   this.deleteDriverHashId = "";
  //   this.childModal.hide();
  // }

  // public SuccessModalClick(): void {
  //   this.childModal.hide();
  //   let deleteDiriverList: any[];
  //   if (this.isMultipleDelete)
  //     deleteDiriverList = this.driverList.filter(x => x.isChecked).map(x => x.driverMasterHashId);
  //   else
  //     deleteDiriverList.push(this.deleteDriverHashId);

  //   this.DeleteDriver(deleteDiriverList);
  //   this.childModal.hide();
  // }

  public InActiveDriver(formData: any) {
    this.isLoading = true;
    this.driverService.InActiveDriver(formData)
      .subscribe(
      res => {
        if (res.data) {
          this.inActiveModal.hide();
          this.DataListModel.currentPage = 1;
          this.GetDriverList();
          this.popupMsg = this.translate.instant('LblRecordBlokUnBlockSuccess', [this.module, this.inActiveMessage]);
          this.ShowSuccessPopup();
        }
        else {
          this.isLoading = false;
          this.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
      );
  }


  public RemoveDriverLicenseBirthDate(formData: any) {
    this.isLoading = true;
    this.driverService.RemoveDriverLicenseBirthDate(formData)
      .subscribe(
      res => {
        if (res.data) {
          this.removeLicenseModel.hide();
          this.DataListModel.currentPage = 1;
          this.GetDriverList();
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.removeLicenseNumber]);
          this.ShowSuccessPopup();
        }
        else {
          this.isLoading = false;
          this.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
      );
  }

  public ShowInActiveModal(vehicleMasterHashId: string, isActive: boolean): void {
    this.inActiveDriverHashId = vehicleMasterHashId;
    this.activeFlag = !isActive;
    this.inActiveMessage = !isActive ? this.translate.instant('LblBlock') : this.translate.instant('LblUnblock');

    this.model.reason = null;
    this.errorModel = null;
    this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [this.inActiveMessage, this.module]);
    this.inActiveModal.show(this.message);
  }

  public ShowRemoveLicenseDetails(driverMasterHashId: string, licenceNumber: string): void {

    this.inActiveDriverHashId = driverMasterHashId;
    this.licenseNumber = licenceNumber;

    this.model.reason = null;
    this.errorModel = null;

    this.removeLicenseNumber = this.translate.instant('LblLicenseBirthDate');

    this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.removeLicenseNumber]);
    this.removeLicenseModel.show(this.message);
  }

  public HideInActiveModal(): void {
    this.inActiveDriverHashId = "";
    this.inActiveModal.hide();
  }

  public SuccessInActiveModalClick(): void {
    this.inActiveModal.hide();
  }

  public SuccessRemoveLicenseBirthDateClick(): void {
    this.removeLicenseModel.hide();
    this.model.driverHashId = this.inActiveDriverHashId;
    this.RemoveDriverLicenseBirthDate(this.model);
  }

  public HideRemoveLicenseBirthDateClick(): void {
    this.inActiveDriverHashId = "";
    this.removeLicenseModel.hide();
  }

  // Add new driver
  public ShowAddDriverModal() {
    this.addDriverModal.show()
  }

  public SuccessAddDriverModal($event: any) {
    this.GetDriverList();
    this.popupMsg = $event.SuccessMessage;
    this.ShowSuccessPopup();
  }

  //Reset group admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = "";
    this.resetPasswordModal.hide();
  }

  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    this.ResetPersonPassword(this.resetPasswordPersonHashId);
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public RedirectoPerson(personHashId: string) {
    this.router.navigate([this.urlPersonUpdate + '/' + personHashId]);
  }

  public ResendActivationMail(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.personService.ReSendActivationMail(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResendActivationMailSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResendActivationMailFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public CheckIsAllowToBatchUploadPerson() {
    if (this.authService.IsGroupAdmin()) {
      this.instanceService.CheckIsAllowToBatchUploadPerson()
        .subscribe(
        res => {
          this.isAllowToBatchUploadPerson = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        });

    }
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/components/driver-list.component.ts